import type { KeyboardEvent } from 'react';

/**
 * Creates a keyboard event handler for textareas that submits on Enter
 * and allows new lines on Shift+Enter
 */
export const createOnEnterHanlder = <T extends HTMLTextAreaElement | HTMLInputElement, I>(
  onSubmit: (e: KeyboardEvent<T>, args?: I) => void,
  options?: {
    /** Whether submission is currently disabled (e.g. during loading) */
    isDisabled?: boolean;
  },
) => {
  return (e: KeyboardEvent<T>, args?: I) => {
    if (e.key === 'Enter' && !e.shiftKey && !options?.isDisabled) {
      e.preventDefault();
      onSubmit(e, args);
    }
  };
};
